import styled from 'styled-components';
import moment from 'moment';
import { media } from '@/styles';

const defaultSize = 4.5;

const TopicCalendarIcon = ({
  date = null,
  size = defaultSize,
  disabled = false,
  ...props
}) => {
  const scale = size / defaultSize;

  return (
    <TopicCalendar
      scale={scale}
      size={size}
      style={{ filter: disabled ? 'grayscale(1)' : 'none' }}
      {...props}>
      <TopicCalendarMonth scale={scale}>
        {date ? moment(date).format('MMM') : null}
      </TopicCalendarMonth>
      <TopicCalendarDay>
        {date ? moment(date).format('D') : null}
      </TopicCalendarDay>
    </TopicCalendar>
  );
};

const TopicCalendar = styled.div`
  aspect-ratio: 1 / 1;
  width: ${props => props.size}rem;
  height: ${props => props.size}rem;
  margin-right: 1rem;
  border-radius: 99rem;
  padding: ${props => 1 * props.scale}rem;
  background-color: var(--green-lighter);
  align-self: center;
  ${media.md`
    align-self: flex-start;
  `}
`;

const TopicCalendarDay = styled.div`
  width: 100%;
  height: ${props => 1.75 * props.scale}rem;
  background-color: var(--white);
  text-align: center;
  font-weight: 500;
  font-size: ${props => 1.5 * props.scale}rem;
  text-align: center;
  padding: ${props => 0.125 * props.scale}rem;
  line-height: 1;
  border-radius: 0 0 0.25rem 0.25rem;
`;
const TopicCalendarMonth = styled.div`
  width: 100%;
  height: ${props => 1 * props.scale}rem;
  background-color: var(--green);
  color: var(--green-lighter);
  font-weight: 500;
  font-size: ${props => 0.75 * props.scale}rem;
  text-align: center;
  padding: ${props => 0.125 * props.scale}rem;
  line-height: ${props => 1 * props.scale};
  border-radius: 0.25rem 0.25rem 0 0;
`;

export default TopicCalendarIcon;
